export enum ContentTypeEnum {
  TermAndPolicy = "Term_and_Policy",
  Policy = "Policy",
  FAQ = "FAQ",
  Article = "Article",
  Refer = "Refer",
  MainSlide = "Main_Slide",
}

export enum ContentStatusEnum {
  Active = "Active",
  Inactive = "Inactive",
}

export interface Slider {
  id: string;
  name: string;
  url: string | null;
  image: string;
  status: ContentStatusEnum;
  order: number;
  content_id: string;
  created_at: string;
  updated_at: string;
}

export interface Content {
  id: string;
  title: string;
  subTitle: string | null;
  content: string;
  status: ContentStatusEnum;
  url: string | null;
  image: string | null;
  type: ContentTypeEnum;
  sliders: Slider[];
  created_at: string;
  updated_at: string;
}

export interface ReferContent {
  title: string;
  subTitle: string | null;
}

export interface BenefitSlide {
  id: string;
  name: string;
  url: string | null;
  image: string;
  order: number;
}
